import github from "../v2/assets/images/github.svg";
import linkedin from "../v2/assets/images/linkedin.svg";
import insta from "../v2/assets/images/instagram.svg";
import email from "../v2/assets/images/mail.svg";
import medium from "../v2/assets/images/medium.svg";

export const SOCIAL = {
  data: [
    {
      name: "GMail",
      link: "mailto:vxkat.360@gmail.com",
      logo: email,
    },
    {
      name: "Github",
      link: "https://github.com/venkatt05",
      logo: github,
    },
    {
      name: "LinkedIn",
      link: "https://www.linkedin.com/in/venkat-x",
      logo: linkedin,
    },
    {
      name: "Medium",
      link: "https://venkatx.medium.com",
      logo: medium,
    },
    {
      name: "Instagram",
      link: "https://www.instagram.com/venkaat__",
      logo: insta,
    },
  ],
};
